define(function (require) {
	const tpl = require('./templates/t_itv_number_field.hbs');
	const detailUtils = require('civicsUtils/detail_utilities');
	const baseElement = require('./v_itv_base_element');
	return baseElement.extend({
		template:tpl,
		templateHelpers:function(){
			//get baseElement Template Helpers
			var baseTH = baseElement.prototype.templateHelpers.apply(this);

			var self = this;
			var val = this.model.get('value');
			if(val == null && this.model.get('isKeyValue') === true){
				var rowCount = $('table[name='+this.config.gridName+']').data('newrowcount');
				this.model.set('value',rowCount);
				val = rowCount;
				$('table[name='+this.config.gridName+']').data('newrowcount',rowCount+1);
			}

			let rangeMinValid = this.getMinValue(this.model.get('dataType'),this.model.get('rangeMinValid'));
			let rangeMaxValid = this.getMaxValue(this.model.get('dataType'),this.model.get('rangeMaxValid'));

			var ret = {
				isRequired: self.model.get('isKeyValue') ? false : self.model.get('isRequired'),
				classes:'text-field-container' + 
					(self.model.get('isVisible') === false ? ' hidden':'') + 
					(self.model.get('fullWidthField') === true ? ' full-width' : ''),

				customAttr:function(){
					var ret = self.model.get('customAttr');
					ret+='data-dataType="' + self.model.get('dataType') + '" ';
					ret += 'data-iskeyvalue="' + (self.model.get('isKeyValue') == true ? 'true' : 'false')+'" ';
					if(rangeMinValid!=null){
						ret += 'data-minVal="'+rangeMinValid+'" ';
					}
					if(rangeMaxValid!=null){
						ret += 'data-maxVal="'+rangeMaxValid+'" ';
					}
					if(self.config.isInGrid){
						ret += 'specialType="grid" ';
					}
					if ( baseTH.tooltip )
					{
						ret+=' data-tooltip="' + baseTH.tooltip + '"';
					}
					ret += 'step="1" ';
					return ret;
				},
				value: function (){
					var number = detailUtils.numberFields(self.model, self.config);
					if(number.isZeroValue.condition){
							return number.isZeroValue.value;
					} else {
						let val = self.model.get('value')
						if(typeof val == 'string' && val != ""){
							let decimalPlaces = self.model.get('decimalPlaces') || 0;
							val = parseFloat(val.replace(/,/g, '')).toFixed(decimalPlaces); //remove commas. decimals will be chopped by the step attribute on the field.
						}
						return val;
					}
				}
			};

			ret = $.extend({},baseTH,ret);
			return ret;
		},
		getValue: function () {
			if (this.model.get('displayOnly') === true) {
				return;
			}
			if (this.model.get('isEnabled') === false || this.config.readOnlyForm) {
				//if we're disabled the value will be on the model.
				return this.model.get('value');
			}
			var val = this.$el.find('input').val();
			if (val != null && (val == "" || val.trim().length == 0)) {
				val = 0;
			}
			return val;
		},
	});
});
